module.exports = __webpack_public_path__ + "img/cow5.cd26d1ae.png";